import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./settings-billing-summary-card.module.scss";
import {
	formatBillingPeriod,
	formatBillingPrice,
} from "./settings-billing-format";
import { classArr } from "../../../helper/style-helper";

export interface SettingsBillingSummaryCardProps {
	className?: string;
	start: string;
	end: string;
	total: number;
}

export default function SettingsBillingSummaryCard(
	props: SettingsBillingSummaryCardProps,
) {
	const { t } = useTranslation();
	const periodText = useMemo(
		() => formatBillingPeriod(props.start, props.end),
		[props.start, props.end],
	);

	return (
		<div className={classArr(styles.card, props.className)}>
			<span className={styles.period}>{periodText}</span>

			<span className={styles.spacer} />

			<span className={styles.toDate}>
				{t("settings.billing.to_date")}
			</span>

			<span className={styles.price}>
				{formatBillingPrice(props.total)}
			</span>
		</div>
	);
}
